import "./assets/style/configs.css";
import "./assets/style/main.css";
import "./assets/style/mainResponsive.css";
import { lazy, Suspense } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import { UiWrapper, Home, About, Services, Blog, BlogPost } from "./components";
import { CMS_BASE } from "./cms/paths";

// Loaded only when the CMS is opened, so site visitors never download it.
const CmsApp = lazy(() => import("./cms/CmsApp"));



function App() {
  return (
    <Router>
      <Routes>
        <Route
          path={`${CMS_BASE}/*`}
          element={
            <Suspense fallback={null}>
              <CmsApp />
            </Suspense>
          }
        />

        <Route
          path="*"
          element={
            <UiWrapper>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/services" element={<Services />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/blog/:id" element={<BlogPost />} />
              </Routes>
            </UiWrapper>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
